import { getAppDownloader } from './api/index';
/**
 * 通用下载器
 */
var AppDownloader = /** @class */ (function () {
    function AppDownloader(opt) {
        this.instance = getAppDownloader(opt);
    }
    return AppDownloader;
}());
export default AppDownloader;
